// Runtime override layer. Mutates the exported `environment` object after it
// is created, so consumers reading it at runtime (services, components) see
// values from window.__env (populated by assets/env.js, which the Docker
// entrypoint generates from container env vars).
//
// Note: values referenced inside Angular decorator metadata (e.g.
// `@NgModule({ imports: [Lib.forRoot({ url: environment.serverUrl }) ] })`)
// are folded into the AOT-compiled factory at build time and CANNOT be
// runtime-overridden. Only values read at runtime are overridable.
export function applyRuntimeEnv<T extends object>(env: T): T {
  if (typeof window === 'undefined') {
    return env;
  }
  const runtime = (window as any).__env;
  if (!runtime || typeof runtime !== 'object') {
    return env;
  }
  Object.assign(env as any, runtime);
  return env;
}
